import { gql } from '@/apollo';

export const IS_ENTRA_ENABLED = gql`
  query IsEntraEnabled {
    isEntraEnabled
  }
`;

export const GET_ENTRA_AUTH_URL = gql`
  query GetEntraAuthUrl {
    getEntraAuthUrl
  }
`;

export const LOGIN_WITH_ENTRA = gql`
  mutation LoginWithEntra($code: String!) {
    loginWithEntra(code: $code) {
      user {
        id
        email
        username
        firstName
        lastName
        role
        authProvider
        isActive
        emailVerified
        lastLoginAt
        createdAt
        updatedAt
      }
    }
  }
`;

